import { 
    IRegistrationService, 
    ProgressService 
} from 'phoenix/services';
const template = require('./login-register-user.template');
const TOAST_POSITION = 'bottom right';
const TOAST_DELAY = 3000;

export function RegisterUserDirective(): ng.IDirective {
    return {
        restrict: 'E',
        controller: LoginRegisterUserController,
        controllerAs: 'vm',
        bindToController: true,
        template,
        scope: {
            authToken: '@',
            email: '@',
            username: '@',
            errorMessage: '=?'
        }
    }
};

export class LoginRegisterUserController {
    public static readonly $inject = [
        '$state',
        '$timeout',
        '$mdToast',
        'gettextCatalog',
        'pxProgressService',
        'pxRegistrationService'
    ];

    // Input bindings
    public username: string;
    public email: string;
    public authToken: string;
    public errorMessage: string;

    // Form bindings
    public password: string = '';
    public confirmPassword: string = '';
    
    private submitting: boolean = false;
    private form: ng.IFormController;

    public get isSubmitting() {
        return this.submitting;
    }

    public set isSubmitting(status:boolean) {
        this.submitting = this.pxProgressService.backdrop = this.pxProgressService.visible = status;
    }

    constructor(
        private readonly $state,
        private readonly $timeout: ng.ITimeoutService,
        private readonly $mdToast,
        private readonly gettextCatalog,
        private readonly pxProgressService:ProgressService,
        private readonly registration: IRegistrationService
    ) { }

    public completeRegistration(): void {
        this.errorMessage = '';

        if (!this.form.$valid) {
            return;
        }

        if (this.password !== this.confirmPassword) {
            this.errorMessage = this.gettextCatalog.getString("New passwords don't match");
        } else {
            this.isSubmitting = true;
            this.registration.validatePassword(this.password, this.authToken)
                .then(result => {
                    if (result.Valid) {
                        this.pxProgressService.text = this.gettextCatalog.getString('Registering your account');
                        return this.registration.registerUser(this.email, this.password, this.username, this.authToken)
                            .then(() => true);
                    } else {
                        this.password = '';
                        this.confirmPassword = '';
                        this.errorMessage = result.Error;
                        return false;
                    }
                })
                .then(result => {
                    if (result) {
                        this.showRegistrationSuccessMessage();
                        this.$state.go('login');
                    }
                })
                .catch(() => {
                    this.errorMessage = this.gettextCatalog.getString('An unknown error has ocurred while processing your registration. Please contact ShareBase technical support.');
                })
                .finally(() => this.isSubmitting = false);
        }
    }

    private showRegistrationSuccessMessage(): void {
        this.$timeout(() => {
            this.$mdToast.show(
                this.$mdToast.simple()
                .textContent(this.gettextCatalog.getString('Your account is now registered, please login to continue'))
                .position(TOAST_POSITION)
                .hideDelay(TOAST_DELAY)
            );
        }, 0);
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/components/login/login-register-user.component.ts